import React from 'react'
import Helmet from 'react-helmet'
import { injectIntl } from 'react-intl'
import {  useQuery } from "@apollo/react-hooks"
import { Link } from 'react-router-dom'
import _ from 'lodash'
import ReactTooltip from 'react-tooltip'

import ManageSideBar from '../../components/Manage/SideNav'
import DocCounter from '../../components/Manage/DocCounter'

import { query } from '../../util/gql'

const SingleAddon = (props) => {
  const translate = (id) => {
    return props.intl.messages[id]
  }

  const { data: myAddonData, loading: myAddonLoading, error: myAddonError} = useQuery(query.getAddonByName, {
    variables: {
      name: props.match.params.addon
    }
  })

  if(myAddonError){
    props.history.push('/manage/addons')
  }

  let myAddon
  let myDocs = {
    events: [],
    conditions: [],
    effects: [],
    expressions: [],
    types: []
  }

  if(myAddonData){
    myAddon = myAddonData.getAddonByName
    myDocs.events = _.filter(myAddon.docs, {type: "event"})
    myDocs.conditions = _.filter(myAddon.docs, {type: "condition"})
    myDocs.effects = _.filter(myAddon.docs, {type: "effect"})
    myDocs.expressions = _.filter(myAddon.docs, {type: "expression"})
    myDocs.types = _.filter(myAddon.docs, {type: "type"})
  }

  return (
    <div id="MyAddons" className="flex-1 bg-skugray-100">
      <Helmet>
        <title>{props.title}</title>
        <meta name="description" content="skUnity Me" />
      </Helmet>
      <div className="flex h-full">
        <ManageSideBar/>
        <div className="flex-1 overflow-y-auto">
          <nav aria-label="breadcrumb" className="fixed w-full px-4 py-2 bg-white shadow-sm">
            <Link to="/manage" className="sku-link">{translate('me.dashboard')}</Link>
            <span className="font-semibold px-2">/</span>
            <Link to="/manage/addons" className="sku-link">{translate('me.myAddons')}</Link>
            <span className="font-semibold px-2">/</span>
            {props.match.params.addon}
          </nav>
          <div className="py-12 px-6 md:px-12 md:py-16">
            <h1 className="font-semibold text-skugray-900 text-2xl">{props.match.params.addon}</h1>
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mt-4">
              <DocCounter loading={myAddonLoading} docs={myDocs} name="Events" />
              <DocCounter loading={myAddonLoading} docs={myDocs} name="Conditions" />
              <DocCounter loading={myAddonLoading} docs={myDocs} name="Effects" />
              <DocCounter loading={myAddonLoading} docs={myDocs} name="Expressions" />
              <DocCounter loading={myAddonLoading} docs={myDocs} name="Types" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mt-4">
              <div className="bg-white py-2 px-4">
                <h2 className="flex-1 font-semibold text-lg">Contributors</h2>
                <div className="py-4">
                  {myAddon && 
                    <div className="inline-block"> 
                      <img className="rounded-full inline h-10 mr-4" src={myAddon.author.avatar} alt={myAddon.author.username} data-tip data-for={myAddon.author.username}/>
                      <ReactTooltip id={myAddon.author.username} place="top" effect="solid">
                        {myAddon.author.username}
                      </ReactTooltip>
                    </div>
                  }
                  {myAddon && myAddon.collaborators.map(contributor => 
                    <div className="inline-block">
                      <img className="rounded-full inline h-10 mr-4" src={contributor.avatar} alt={contributor.username} data-tip data-for={contributor.username}/>
                      <ReactTooltip id={contributor.username} place="top" effect="solid" html={true}>
                        {contributor.username}
                      </ReactTooltip>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default injectIntl(SingleAddon)